import { atom } from "jotai";

/**
 * State machine for the test recorder. The lifecycle is:
 * idle → recording → stopped → uploading → analysing → ready
 *                              ↘ error (from any state)
 *
 * Mutable resources (`MediaRecorder`, `MediaStream`, the preview TipTap
 * `Editor` instance, the in-memory `Blob`) are intentionally not stored
 * here — they are not serialisable and their lifetime is tied to the
 * recorder hook + dialog component.
 */
export type RecorderState =
  | "idle"
  | "recording"
  | "stopped"
  | "uploading"
  | "analysing"
  | "ready"
  | "error";

export interface RecorderError {
  stage: "record" | "upload" | "analyse";
  message: string;
}

export const recorderStateAtom = atom<RecorderState>("idle");
export const recorderElapsedMsAtom = atom<number>(0);
export const recorderUploadProgressAtom = atom<number>(0);
export const recorderHasAudioAtom = atom<boolean>(false);
export const recorderGeneratedMarkdownAtom = atom<string | null>(null);
export const recorderErrorAtom = atom<RecorderError | null>(null);
